import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AdminAccountForm, UsersPermissionsPageFilterForm } from 'src/app/shared/interfaces';
import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { AdminQuery } from '../model';
import { BaseAPI } from './base-api';
import { AccountDataModel } from '../model/account-data-model';

@Injectable({
  providedIn: 'root',
})
export class UsersPermissionsApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getAdminsList(filter: UsersPermissionsPageFilterForm): Observable<DataWithPagination<AdminQuery[]>> {
    return this.baseAPI.post(Constants.GET_ADMINS_QUERY_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<AdminQuery[]> = {
          data: this.mapper.fromListJson(AdminQuery, res.items),
          count: res.count,
        };
        return data;
      })
    );
  }

  getUser(adminId: string): Observable<AccountDataModel> {
    return this.baseAPI
      .post(Constants.GET_ADMIN_ACCOUNT_API_URL, {adminId})
      .pipe(map((res) => {
        return this.mapper.fromJson(AccountDataModel, res)
      }))
  }

  addUser(form: AdminAccountForm): Observable<AdminQuery> {
    return this.baseAPI.post(Constants.ADD_USER_ADMIN_API_URL, form).pipe(map((res) => this.mapper.fromJson(AdminQuery , res.data)));
  }

  updateUser(admin: AdminAccountForm) : Observable<string>{
    return this.baseAPI.post(Constants.UPDATE_ADMIN_PERMISSION_API_URL , {permission : [admin]}).pipe(map(res=>res.message))
  }
}
